<template>
  <Header/>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div">
          <Toast/>
          <ConfirmDialog/>
          <div class="d-flex justify-content-around mb-3 mt-3">
            <Card style="width: 35rem;">
              <template #title>
                Preview Create
              </template>
              <template #content>
                <div class="row mb-3 mt-3">
                  <div v-for="(field, index) in formFields" :key="index" class="col-md-12 form-group">
                    <div v-if="field.type !== 'date' || (field.type === 'date' && formData.path)" class="d-flex gap-2 align-items-center mt-2 mb-2">
                      <label :for="field.model">{{ field.label }}<span v-if="field.required">*</span></label>
                      <ToolsPopover v-if="field.popoverText" :text="field.popoverText"/>
                      <a :href="field.buttonRedirect"  target="_blank" v-if="field.buttonRedirect" class="text-white p-button p-component p-button-info d-inline me-2">
                        FastAPI
                      </a>
                    </div>


                    <input v-if="field.type === 'text'"
                           :id="field.model"
                           :placeholder="field.placeholder"
                           v-model="formData[field.model]"
                           type="text"
                           class="form-control w-100" />

                    <select v-else-if="field.type === 'select'"
                            :id="field.model"
                            v-model="formData[field.model]"
                            class="form-control w-100">
                      <option value="" disabled>Select an option</option>
                      <option v-for="option in this.signs" :key="option[field.id]"   :value="option[field.id]">
                        {{ option[field.value] }}
                      </option>
                    </select>

                    <!-- Text-Select (both dropdown and input) -->
                    <div v-else-if="field.type === 'text-select'" class="d-flex gap-2">
                      <select
                          :id="field.model + '-select'"
                          class="form-control w-50"
                          @change="formData[field.model] = $event.target.value"
                      >
                        <option disabled value="" selected hidden>Select the path</option>
                        <option v-for="option in field.options" :key="option" :value="option">
                          {{ option }}
                        </option>
                      </select>
                      <input
                          :id="field.model"
                          :placeholder="field.placeholder"
                          v-model="formData[field.model]"
                          type="text"
                          class="form-control w-50"
                      />
                    </div>

                    <!-- Text area -->
                    <textarea v-else-if="field.type === 'textarea'"
                              :id="field.model"
                              :placeholder="field.placeholder"
                              v-model="formData[field.model]"
                              type="text"
                              class="form-control w-100" />

                    <Dropdown v-else-if="field.type === 'drop'"
                              v-model="formData[field.model]"
                              :options="field.options"
                              :optionLabel="field.value"
                              :optionValue="field.id"
                              class="w-100"
                    />

                    <Calendar
                        v-else-if="field.type === 'date' && formData.path === 'weekly/generate'"
                        v-model="formData[field.model]"
                        :manualInput="false"
                        :disabled-days="[1, 2, 3, 4, 5, 6]"
                        selection-mode="range"
                        :readonlyInput="true"
                        showIcon
                        dateFormat="yy-mm-dd"
                        class="w-full w-100"
                        @date-select="onWeeklyDateSelect"
                    />


                    <Calendar
                        v-else-if="field.type === 'date' && formData.path === 'monthly/generate'"
                        class="w-100"
                        v-model="formData[field.model]"
                        showIcon
                        dateFormat="mm.yy"
                        view="month"
                        @date-select="onMonthSelect"
                    />
                  </div>
                </div>
              </template>
              <template #footer>
                <Button @click="fetchAPI()" label="Preview Create"/>
              </template>
            </Card>
            <Card style="width: 45rem;">
              <template #title>
                Response
              </template>
              <template #content>
                <div v-if="APIResult == null">
                  <div v-for="i in 10" :key="i">
                    <Skeleton class="mb-3"/>
                  </div>
                </div>
                <VueJsonPretty
                    v-else
                    :data="APIResult"
                    :show-length="true"
                    :deep="2"
                    :highlight-mouseover-node="true"
                    :show-line="true"
                    :collapsed="false"
                />

                <button v-if="APIResult !== '' && APIResult !== null" type="submit" class="btn btn-primary" @click="previewDetailModal = true">Save</button>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </main>

  <Dialog v-model:visible="previewDetailModal" :modal="true" :style="{width: '50vw'}" :header="'Preview edit'">
    <div style="display: flex;justify-content: center;">
      <div class="modal-overlay" @click="previewDetailModal=false">
        <div class="modal-content" @click.stop>
          <TabView>
            <TabPanel v-for="(item, itemIndex) in reports" :key="itemIndex" :header="'Durum ' + (itemIndex + 1)">
              <div class="mb-4 p-3 rounded">
                <h5>Durum {{ itemIndex + 1 }}</h5>

                <div class="form-group">
                  <label>Zodiac Sign</label>
                  <InputText v-model="item.zodiacSign" class="form-control w-100 w-full" :disabled="true"/>
                </div>

                <div class="form-group">
                  <label>Work Status</label>
                  <InputText v-model="item.workStatus" class="form-control w-100 w-full" :disabled="true"/>
                </div>

                <div class="form-group">
                  <label>Relationship Status</label>
                  <InputText v-model="item.relationshipStatus" class="form-control w-100 w-full" :disabled="true"/>
                </div>

                <div class="form-group">
                  <label>Content</label>
                  <textarea v-model="item.content" class="form-control w-100 w-full" autoResize rows="8" />
                </div>

                <div class="form-group">
                  <label>Preview</label>
                  <textarea v-model="item.preview" class="form-control w-100 w-full" autoResize rows="8"/>
                </div>
              </div>
            </TabPanel>
          </TabView>

          <div style="padding: 1.25rem">
            <div class="mb-3 d-flex flex-column justify-content-between">
              <label>Title</label>
              <InputText v-model="title"  class="w-full w-100" />
            </div>
            <div class="mb-3 d-flex flex-column justify-content-between">
              <label>Story Prefix</label>
              <InputText v-model="storyPrefix"  class="w-full w-100" />
            </div>

            <div class="d-flex justify-content-end gap-3">
              <Button label="Kaydet" class="p-button-info mt-3" @click="saveContent" />
              <Button class="p-button-danger mt-3" @click="previewDetailModal=false">Close</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Dialog>


</template>

<script>
import Header from "@/components/Header.vue";
import Button from "primevue/button";
import "@vuepic/vue-datepicker/dist/main.css";
import Card from 'primevue/card';
import Dropdown from "primevue/dropdown";
import Datepicker from "@vuepic/vue-datepicker";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import Skeleton from 'primevue/skeleton';
import {mapGetters} from "vuex";
import dayjs from "dayjs";

export default {
  name: "PreviewCreate",
  components: {
    Header,
    Card,
    Button,
    Dropdown,
    Datepicker,
    VueJsonPretty,
    Skeleton,
  },
  data() {
    return {
      formFields: [
        { label: 'Language', type: 'drop', model: 'language', placeholder: 'Enter language', options: this.supportedLanguages , id: 'id', value: 'name' },
        { label: 'Raw Astrological Content', type: 'textarea', model: 'rawAstrologicalContent', required: false },
        { label: 'Path', type: 'text-select', model: 'path', placeholder: 'Enter the path', options: ['weekly/generate', 'monthly/generate'],popoverText:"Path alanı, API endpoint bilgisini tanımlamak için kullanılır. Bu alan, hem hazır seçeneklerden (select) seçim yaparak hem de manuel olarak metin girişiyle doldurulabilir.", buttonRedirect: "https://aiservice.astopia.com/docs", required: false },
        { label: 'Sign', type: 'select', model: 'sign', options: this.signs, id: 'name', value: 'name', required: false },
        { label: 'Date', type: 'date', model: 'date', required: false },
      ],
      formData: {},
      APIResult: '',
      editableAPIResult: "",
      signs: [
        {
          "id": 1,
          "name": "Aries"
        },
        {
          "id": 2,
          "name": "Taurus"
        },
        {
          "id": 3,
          "name": "Gemini"
        },
        {
          "id": 4,
          "name": "Cancer"
        },
        {
          "id": 5,
          "name": "Leo"
        },
        {
          "id": 6,
          "name": "Virgo"
        },
        {
          "id": 7,
          "name": "Libra"
        },
        {
          "id": 8,
          "name": "Scorpio"
        },
        {
          "id": 9,
          "name": "Sagittarius"
        },
        {
          "id": 10,
          "name": "Capricorn"
        },
        {
          "id": 11,
          "name": "Aquarius"
        },
        {
          "id": 12,
          "name": "Pisces"
        }
      ],
      previewDetailModal: false,
      reports: [],
      startDate: null,
      endDate: null,
      title: null,
      storyPrefix: null,
      contentType: 'daily', // örnek
      language: 'tr',
    };
  },
  watch: {
    supportedLanguages: {
      handler(newVal) {
        this.formFields = [
          {
            label: "Language",
            type: "drop",
            model: "language",
            placeholder: "Enter language",
            options: newVal,
            id: "id",
            value: "name",
          },
          { label: "Raw Astrological Content", type: "textarea", model: "rawAstrologicalContent", required: false },
          { label: 'Path', type: 'text-select', model: 'path', placeholder: 'Enter the path', options: ['weekly/generate', 'monthly/generate'], popoverText:"Path alanı, API endpoint bilgisini tanımlamak için kullanılır. Bu alan, hem hazır seçeneklerden (select) seçim yaparak hem de manuel olarak metin girişiyle doldurulabilir.", buttonRedirect: "https://aiservice.astopia.com/docs", required: false },
          { label: 'Sign', type: 'select', model: 'sign', options: this.signs, id: 'name', value: 'name', required: false },
          { label: 'Date', type: 'date', model: 'date', required: false },
        ];
      },
      immediate: true,
    },
    APIResult: {
      handler(newVal) {
        if (newVal?.response?.reports) {
          this.reports = newVal.response.reports;
          console.log("Güncellenmiş reports:", this.reports);
        }
      },
      immediate: true,
      deep: true
    },
    'formData.path'(newPath) {
      if (newPath === 'weekly/generate') {
        this.formData.date = null;
      } else if (newPath === 'monthly/generate') {
        this.formData.date = null;
      }
    }
  },
  methods: {
    fetchAPI() {
      if (!this.formData.path) return;
      this.APIResult = null;
      this.$appAxios.post("/admin/customize-content/preview-create", this.formData)
          .then(resp => {

            if(typeof resp.data === 'string'){
              this.APIResult = JSON.parse(resp.data)
            }else {
              this.APIResult = resp.data
            }


          })
          .catch(err => {
            this.APIResult = err.response
          });
    },
    saveContent() {
      const flattenedRequests = this.reports.flat();

      const payload = {
        request: flattenedRequests,
        contentType: this.formData?.path?.split('/')[0],
        language: this.formData?.language,
        startDate: this.formData.startDate,
        endDate: this.formData.endDate,
        title: this.title,
        storyPrefix: this.storyPrefix
      };

      this.$appAxios.post('/admin/customize-content/preview-content-create', payload)
          .then(() => {
            this.$toast.add({ severity: 'success', summary: 'Başarılı', detail: 'İçerik başarıyla kaydedildi.', life: 3000 });
          })
          .catch(() => {
            this.$toast.add({ severity: 'error', summary: 'Hata', detail: 'İçerik kaydedilemedi.', life: 3000 });
          });
    },
    onWeeklyDateSelect(selectedDate) {
      const timezoneOffsetMs = new Date().getTimezoneOffset() * 60 * 1000;

      const start = dayjs(selectedDate).startOf("day").subtract(timezoneOffsetMs, 'millisecond');
      const end = start.add(7, 'day');

      this.formData.date = [start.toDate(), end.toDate()];

      this.formData.startDate = start.toISOString();
      this.formData.endDate = end.toISOString();
    },
    onMonthSelect(selectedDate) {
      if (!selectedDate) return;

      const year = selectedDate.getFullYear();
      const month = selectedDate.getMonth();

      const startDate = new Date(Date.UTC(year, month, 1, 0, 0, 0));

      const endDate = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59, 999));

      this.formData.startDate = startDate.toISOString();
      this.formData.endDate = endDate.toISOString();
    }
  },
  computed: {
    ...mapGetters(['supportedLanguages']),
  }

};
</script>
<style scoped>
.p-button-sm {
  height: 35px;
  width: 35px;
  font-size: 0.875rem;
  padding: 0.7rem;
}

.p-disabled,
.p-component:disabled {
  opacity: 0.8;
}

.p-dropdown {
  min-width: 200px;
}

.vue-json-pretty {
  font-family: monospace;
  background: #282c34;
  color: white;
  padding: 15px;
  border-radius: 8px;
  overflow-x: auto;
}


</style>
  